// extracted by mini-css-extract-plugin
export default {"image":"w5-z","loaded":"x5-z"};